import type { KeyValueStorageInterface } from 'aws-amplify/utils';

export const createClientLocalStorage = (): KeyValueStorageInterface => {
  return {
    setItem: async (key: string, value: string) => {
      window.localStorage?.setItem(key, value);
    },

    getItem: async (key: string) => {
      return window.localStorage?.getItem(key) ?? null;
    },

    removeItem: async (key: string) => {
      window.localStorage?.removeItem(key);
    },

    clear: async () => {
      window.localStorage?.clear();
    },
  };
};
